<template>
  <div class="row">
    <div class=" col-lg-12">
      <div class="card card-custom">
        <div class="card-header">
          <h4 class="card-title">Let’s Connect</h4>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="auto-field col-lg-4 col-md-6 col-sm-12">
              <div class="form-group">
                <label class="control-label">Category</label>
                <v-select v-model="obj.ComplaintCategoryID" :options="category" label="Title" :reduce="i => i.ID" placeholder="-- Select Category --" />
              </div>
            </div>
            <div class="auto-field col-lg-4 col-md-6 col-sm-12">
              <div class="form-group">
                <label class="control-label">Image</label>
                <input type="file" class="form-control form-control-sm" @change="handleFileUpload" accept="image/*,application/jpeg" />
              </div>
            </div>
            <div class="auto-field col-lg-12 col-md-6 col-sm-12">
              <div class="form-group">
                <label class="control-label">Message</label>
                <textarea class="form-control form-control-sm" v-model="obj.Complain"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer " style="margin-top:15px; padding-top: 7px; padding-bottom: 7px">
          <button type="button" class="btn btn-success" style="float:right" @click="save()">Submit</button>
        </div>
      </div>
    </div>
    <div class=" col-lg-12">
      <div class="card card-custom">
        <div class="card-header">
          <h6 class="card-title text-center"><b>History</b></h6>
        </div>
        <div class="card-body box-profile">
          <div>
            <table class="table table-bordered table-sm" id="tbl">
              <thead class="bg-custom">
                <tr>
                  <th style="width:4%">Sr.</th>
                  <th style="width:20%">Category</th>
                  <th style="width:12%">Date</th>
                  <th>Message</th>
                  <!--<th style="width:12%">Complain Status</th>-->
                  <!--<th>Remarks</th>-->
                  <th style="width:11%">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(i,ind) in complaint">
                  <td>{{ ind + 1}}</td>
                  <td>{{i.ComplaintCategory}}<span class="badge badge-primary ml-1">{{i.ComplainStatus}}</span></td>
                  <td>{{i.Date.split('T')[0]}}</td>
                  <td>{{i.Complain}}</td>
                  <!--<td>{{i.ComplainStatus}}</td>-->
                  <!--<td>{{i.Remarks}}</td>-->
                  <td><button type="button" class="btn btn-primary btn-xs" @click="downloadAttachment(i.Attachment)">View Attachment</button></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios';
  export default {
    data() {
      return {
        obj: {
          ComplaintCategoryID: 0,
          Complain: "",
          Attachment: '',
        },

        //com: {
        //    Complain: '',
        //    FullName: '',
        //    ComplainStatus: '',
        //    Remarks: '',
        //},
        category: [],
        complaint: [],
        ComplaintID: 0,
      }
    },

    created: function () {
      this.pageLoad();
    },
    updated() {
      $("#tbl").DataTable();
    },
    methods: {
      pageLoad() {
        var vm = this;
        //const urlParams = new URLSearchParams(window.location.search);
        //this.ComplaintID = Number(urlParams.get('ComplaintID'));
        axios.get("/api/PortalApi/pageLoadComplaint")
          .then(function (res) {
            vm.category = res.data.category;
            vm.complaint = res.data.complaint;
            var table = $("#tbl").DataTable();
            table.destroy();
          })
          .catch((error) => {
            console.log(error);
          })
      },
      handleFileUpload(event) {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
          this.obj.Attachment = reader.result;
        };
        reader.readAsDataURL(file);
        },
        
      save() {
        if (this.obj.ComplaintCategoryID == 0) {
          toastr.error("Category is required");
          return;
          }
          if (this.obj.Complain == "") {
          toastr.error("Please Enter Message");
          return;
        }
          startReq();
        axios.post("/api/PortalApi/saveComplaint", {
          complaint: this.obj
        })
          .then(res => {
            endReq();
            toastr.success(res.data.msg);
            window.location.href = "/Portal/Complaints";

          })
          .catch(error => {
            endReq();
            console.error(error);
          });
      },

      downloadAttachment(path) {
        if (!path) {
          alert('Attachment not found');
          return;
        }

        var link = document.createElement('a');

        link.href = path;
        link.download = '';
        link.target = '_blank';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
  };</script>

<style scoped>
  .nav-tabs.flex-column .nav-item.show .nav-link, .nav-tabs.flex-column .nav-link.active {
    border-left: 3px solid #17a2b8;
  }

  .nav-item active {
    background-color: #17a2b8
  }

  .list-group-item {
    padding: 2px 0px;
  }

  .profile-username {
    font-size: 20px;
    margin-top: 5px;
  }

  .nav-link {
    font-weight: 600;
  }

  textarea {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/school/complaint/Complaints.vue